import styled, { css } from 'styled-components';
import { rem } from '../../utils';
export const cssOutlineEffect = css `
  ${({ theme }) => css `
    transition: box-shadow ${({ theme }) => theme.Transition.Timing.Out};

    &:hover {
      box-shadow: 0 0 0 1.5px ${theme.Color.Brand.Primary};
      transition: box-shadow ${({ theme }) => theme.Transition.Timing.In};
    }
  `}

  ${({ variant, theme }) => {
    switch (variant) {
        case 'filled':
            return css `
          background-color: ${theme.Color.Neutrals.Light};
        `;
        case 'outlined':
            return css `
          background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
          box-shadow: 0 0 0 1px ${theme.Color.Neutrals.Border};
        `;
    }
}}
`;
export const CardContainer = styled.article `
  ${cssOutlineEffect}
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
`;
export const StyledHeaderWrapper = styled.header `
  display: flex;
  flex-flow: row;
  align-items: center;
  width: 100%;
  height: 40px;
  gap: ${({ theme }) => rem(theme.Spacing.Size.XSmall)};
  padding: ${({ theme }) => rem(theme.Spacing.Size.Small)};
  border-radius: ${({ theme }) => rem(theme.Border.Radius.Medium)};
  cursor: pointer;
  user-select: none;

  ${({ theme, hasChildren, variant }) => hasChildren &&
    `
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    ${variant === 'outlined' &&
        `border-bottom: 1px ${theme.Color.Neutrals.Border} solid;`}
  `}
`;
export const StyledHeaderExtraContent = styled.div `
  margin-left: auto;
`;
export const CardBody = styled.section `
  padding: ${({ theme }) => `${rem(theme.Spacing.Size.Small)}`};
`;
//# sourceMappingURL=Card.style.js.map